import * as React from 'react';
import { UserIconSvg } from '../SvgImports';

const UserIcon = (props: {title?: string}) => {
    return (
        <img className="svgIcon userIcon" src={UserIconSvg} alt="User icon" title={props.title} />
    );
};

export default UserIcon;